/*============================================================================

	Main javascript for www.smit-grey.com

	Author: Sofus Graae
	Version: 3
	Release: 2016
	Owner: SMITH GREY LTD

==============================================================================*/


(function ( $, window, document, undefined ) {

	var sg = {

/*============================================================================
	cached selectors
==============================================================================*/

		cached : {

			page : {
				$html           : $( 'html' ),
				$body           : $( 'body' )
			}, // end sg.cached.page
			nav : {
				$menuDrawer     : $( '.menu-drawer' ),
				$categoryWrap   : $( '.category-wrapper' ),
				$navIcons       : $( '.site-nav-icon' ),
				$navSearch      : $( '.nav-search'),
				$navCurrency    : $( '.nav-currency' ),
				$navCart        : $( '.nav-cart' ),
				$navMobileMenu  : $( '.nav-mobilemenu' ),
				$menuTabs       : $( '.js-menu-tab' ),
				$categoryLink   : $( '.collection-link' )
			}, // end sg.cached.nav
			ui : {
				$overlay        : $( '#content-overlay' ),
				$siteNavSearch  : $( '.site-nav--search-results' ),
				$siteNavCart    : $( '.site-nav--cart' ),
				$siteNavCurrency: $( '.site-nav--currency' ),
				$siteNavMobile  : $( '.site-nav--mobilemenu' ),
				$resultsList    : $( '.search-results' ),
				$cartBtnWrapper : $( '#cart--checkout-btn-wrapper' ),
				$popBackground 	: $( '.pop-window-background' )
			}, // end sg.cached.ui
			btn : {
				$btnIconSearch  : $( '#sg-btn-icon--search' ),
				$btnIconCart    : $( '#sg-btn-icon--cart' ),
				$btnIconCurrency: $( '#sg-btn-icon--currency' ),
				$btnIconMenu    : $( '#sg-btn-icon--menu' ),
				$searchInput    : $( '.js-main-search-input' ),
				$btnFurl        : $( '.furl__title' ),
				$currencyPicker : $( '.currency-picker' ),
				$sizePicker     : $( '.size-option-picker' ),
				$loadMoreContent: $( '#moodboard-loadmore' ),
				$popOpener 			: $( '.pop-opener' ),
				$popDismiss 		: $( '.pop-window-close' )
			}, // end sg.cached.btn
			newsletter : {
				$signupBtn 			: $( '.mc-subscribe-btn' )
			}, // end sg.cached.newsletter
			collection : {
				$sortByType     : $( '#sortByType' ),
				$sortByMaterial : $( '#sortByMaterial' ),
				$sortByPrice    : $( '#sortByPrice' ),
				$paginationUi   : $( 'div.pagination' ),
				$productList    : $( '#collection-products__listing'),
				$productEntries : $( '.product-entry' ),
				$visibleProducts: $( '.lazy-entry' ),
				$viewToggleBtn  : $( 'button#viewToggle' )
			}, // end sg.cached.collection
			products : {
				$btnBuy         : $( '#js-btnbuy' ),
				$sizeSelector   : $( '#productSelector' ),
				$sizeLabel      : $( '#sizeOptionLabel' ),
				$imageGallery   : $( '.product-images__gallery' ),
				$personaliser 	: $( '#js-product-personalisation' ),
				$addonAccept 		: $( '#product_addon_accpet-label' ),
				$engravingInput : $( '.engraving-input' )
			}, // end sg.cached.products

			pages : {
				$moodboardWrap 	: $( '#moodboard-entries-wrapper' ),
				$contentLoading : $( '.content-loading-overlay' )
			}, // end sg.cached.pages
			tumblr : {
				$name 					: "https://api.tumblr.com/v2/blog/smithgrey.tumblr.com",
				$key  					: "MLLMH6fXoPLBBznTpSkUQXNVk6Asw4gRbMjpepANZwYNh5fcT4",
				$limit 					: 25,
				$offset 				: 0
			}, // end sg.cached.tumblr
			flags : {
				secureCookies   : true,
				moodboardLoading: false
			}, // end sg.cached.flags


			layout : {
				$masthead : $( '.masthead' ),
				$docks : $( '.dock' ),
				$layoutOverlay : $( '.layout-overlay' ),
				$main : $( '.main' )
			},

			menu : {
				$iconMenuTab : $( '.icon-menu__tab' ),
				$iconSpan : $( '.icon-menu__tab--icon' )
			},

			mobileMenu : {
				$dockIconBtn : $( '.dock__header-icon' ),
				$dockIconContent : $( '.dock__header-content' )
			}


		}, // end sg.cached

/*============================================================================
	utilities
==============================================================================*/

		utilities : {
			toggleOverlay : function( state ) {
				if ( state === 'show' ) {
					sg.cached.ui.$overlay.stop( true ).fadeIn( 'fast', function(){
						sg.cached.page.$html.add( sg.cached.page.$body ).addClass( 'no-scroll' );
					});
				} 
				else if ( state === 'hide' ) {
					sg.cached.ui.$overlay.stop( true ).fadeOut( 'fast', function(){
						sg.cached.page.$html.add( sg.cached.page.$body ).removeClass( 'no-scroll' );
					});
				}
			}, // end sg.utilities.toggleOverlay()
			furl : function( current ) {
				var
				$title   = current,
				$target  = $title.attr( 'id' ),
				$parent  = $title.data( 'scrollparent' ),
				$wrapper = $title.parent( '.furl' ),
				$content = $title.next( '.furl__content' );

				if ( $title.hasClass( 'expanded' ) ){
					$content.stop( true ).slideUp('fast');
					$title.removeClass('expanded active');
					$title.children('span.icon').removeClass('sg-nav-expand').addClass('sg-nav-next active'); 
				}
				else {
					$wrapper.children( '.furl__content' ).each( function() {
						$(this).stop( true ).slideUp( 'fast' );
					});
					$wrapper.children('.furl__title').each( function() {
						$(this).removeClass( 'expanded active' );
						$(this).children( 'span.icon' ).removeClass( 'sg-nav-expand' ).addClass( 'sg-nav-next active' );
					});
					$content.stop( true ).slideDown( 'fast', function() {
						if ( $parent ) {
							$( '.'+$parent ).scrollTo( document.getElementById( $target ), 300 );
						}
						else {
							if (typeof $( '#'+$target ).data( 'reframe' ) != 'undefined' ) {
								var
								width = $( '#'+$target ).data( 'reframe'),
								windowWidth = $( window ).width();
								if ( width == 'small' && windowWidth < 481 ) {
									$.scrollTo( document.getElementById( $target ), 300, { offset: -60 } );
								}
								else if ( width == 'all' ) {
									$.scrollTo( document.getElementById( $target ), 300, { offset: -60 } );
								}
							}
						}
					});
					$title.addClass( 'expanded active' );
					$title.children( 'span.icon' ).removeClass( 'sg-nav-next active' ).addClass( 'sg-nav-expand' );
				} // end else
			} // end sg.utilities.furl()
		}, // end sg.utilities

/*============================================================================
	navigation
==============================================================================*/

		navigation : {

			toggleLayoutOverlay : function( state ) {
				var
				$overlay = sg.cached.layout.$layoutOverlay,
				$main = sg.cached.layout.$main;

				if ( state === 'show' ) {
					$overlay.removeClass( 'is-hidden' ).addClass( 'is-visible' );
					$main.addClass( 'is-blurred' );

				} else if ( state === 'hide' ) {
					$overlay.removeClass( 'is-visible' ).addClass( 'is-hidden' );
					$main.removeClass( 'is-blurred' );
				}
			}, // sg.navigation.toggleLayoutOverlay

			toggleIconMenu : function( current ) {
				var
				$current = current,
				$handler = $current.data( 'dockhandler' );

				if ( $current.hasClass( 'is-active') ) {
					$current.removeClass( 'is-active' );
					sg.cached.menu.$iconSpan.removeClass( 'sg-close' );
					sg.cached.layout.$docks.removeClass( 'is-active' );
					sg.navigation.toggleLayoutOverlay( 'hide' );
				
				} else {
					sg.cached.menu.$iconMenuTab.removeClass( 'is-active' );
					$current.addClass( 'is-active' );
					
					sg.cached.menu.$iconSpan.removeClass( 'sg-close' );
					$current.children( '.icon' ).addClass( 'sg-close' );
					
					sg.cached.layout.$docks.removeClass( 'is-active' );
					$( '.'+$handler ).addClass( 'is-active' );
					sg.navigation.toggleLayoutOverlay( 'show' );
				}
			}, // sg.navigation.toggleIconMenu

			toggleMobileFurl : function( current ) {
				var
				$current = current,
				$handler = $current.data( 'iconhandler' );

				if ( $current.hasClass( 'is-active') ) {
					sg.cached.mobileMenu.$dockIconBtn.removeClass( 'is-active' );
					sg.cached.mobileMenu.$dockIconContent.removeClass( 'is-expanded' ).stop( true ).slideUp( 'fast');
				
				} else {
					sg.cached.mobileMenu.$dockIconBtn.removeClass( 'is-active' );
					$current.addClass( 'is-active' );
					sg.cached.mobileMenu.$dockIconContent.removeClass( 'is-expanded' ).stop( true ).slideUp( 'fast');
					$( '.'+$handler ).addClass( 'is-expanded' ).stop( true ).slideDown( 'fast');
				}
			},









			toggleMenu : function( state, current ) {
				sg.navigation.toggleCurrency( 'hide', true );
				sg.navigation.toggleCart( 'hide', true );
				sg.navigation.toggleSearch( 'hide', true );
				sg.navigation.toggleMobileMenu( 'hide', true );

				var
				$selectedTab  = current,
				$handle       = $selectedTab.data( 'handle' );

				// hardcoded overwrite for two menu points without submenus
				if ( $selectedTab.data( 'handle' ) === 'stockists' || $selectedTab.data( 'handle' ) === 'contact' ) {
					// do as normally.
					sg.cached.nav.$categoryWrap.each( function() {
						$( this ).stop( true, true ).slideUp( 'fast' );
					});
					sg.cached.nav.$menuTabs.each( function() {
						$( this ).removeClass( 'js-tab-visible' );
					});
				}
				else {
					event.preventDefault();
					if ( $selectedTab.hasClass('js-tab-visible') ) {
						sg.navigation.closeAllMenu();
					} else {
						sg.cached.nav.$menuTabs.each( function(){
							if ( $(this).hasClass('js-tab-visible') ) {
								$(this).removeClass('js-tab-visible');
								sg.cached.nav.$categoryWrap.each( function(){
									if ( $( this ).attr( "id" ) !== $handle ) {
										$( this ).stop( true, true ).slideUp('fast');
									} // end if
								}); // end category each
							} // end if
						}); // end menutabs each
						$selectedTab.addClass('js-tab-visible');
						var match = 0;
						sg.cached.nav.$categoryWrap.each( function(){
							if ( $( this ).attr( "id" ) === $handle ) {
								$( this ).stop( true, true ).delay( 111 ).slideDown('slow');
								sg.utilities.toggleOverlay( 'show' ); 
								match++;
							}
						});
						if ( match <= 0 ) {
							sg.utilities.toggleOverlay( 'hide' );
						}
					}
				} // end else
			}, // end sg.navigation.toggleMenu

			toggleMobileMenu : function( state, overlay ) {
				
				if ( sg.cached.nav.$navMobileMenu.hasClass( 'js-tab-visible' ) ) {
					state = 'hide';
				};
				if ( state === 'show' ) {
					sg.navigation.toggleCurrency( 'hide', true );
					sg.navigation.toggleCart( 'hide', true );
					sg.navigation.toggleSearch( 'hide', true );

					sg.cached.ui.$siteNavMobile.show();
					sg.cached.nav.$menuDrawer.addClass( 'active' ); 

					sg.cached.btn.$btnIconMenu.parent('a').addClass( 'active-tab' );
					sg.cached.btn.$btnIconMenu.removeClass( 'sg-search' ).addClass( 'sg-close' );

					sg.cached.nav.$navMobileMenu.addClass('js-tab-visible');

					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'show' );
					}
				}
				else if ( state === 'hide' ) {

					sg.cached.ui.$siteNavMobile.hide();
					sg.cached.nav.$menuDrawer.removeClass('.active');
					
					sg.cached.nav.$navMobileMenu.removeClass('js-tab-visible');
					sg.cached.btn.$btnIconMenu.removeClass('sg-close').addClass('sg-menu');
					sg.cached.btn.$btnIconMenu.parent('a').removeClass('active-tab');

					if ( overlay === true ) {
						sg.utilities.toggleOverlay ( 'hide' );
					}
				}
			}, // end sg.navigation.toggleMobileMenu

			toggleSearch : function( state, overlay ) {
				
				if ( sg.cached.nav.$navSearch.hasClass( 'js-tab-visible' ) ) {
					state = 'hide';
				};
				if ( state === 'show' ) {
					// switch off the other menus if open:
					sg.navigation.toggleCurrency( 'hide', true );
					sg.navigation.toggleCart( 'hide', true );
					sg.navigation.toggleMobileMenu( 'hide', true );
					
					sg.cached.btn.$searchInput.addClass( 'active' ).focus();
					sg.cached.ui.$siteNavSearch.show();
					sg.cached.btn.$btnIconSearch.parent('a').addClass( 'active-tab' );
					sg.cached.btn.$btnIconSearch.removeClass( 'sg-search' ).addClass( 'sg-close' );
					sg.cached.nav.$navSearch.addClass('js-tab-visible');
					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'show' );
					}
				}
				else if ( state === 'hide' ) {
					sg.cached.btn.$searchInput.removeClass("active");        
					sg.cached.ui.$siteNavSearch.hide();
					sg.cached.nav.$navSearch.removeClass('js-tab-visible');
					sg.cached.btn.$btnIconSearch.removeClass('sg-close').addClass('sg-search');
					sg.cached.btn.$btnIconSearch.parent('a').removeClass('active-tab');

					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'hide' );
					}
				}
			}, // end sg.navigation.toggleSearch

			toggleCurrency: function( state, overlay ) {  
				if ( sg.cached.nav.$navCurrency.hasClass( 'js-tab-visible' ) ) {
					state = 'hide';
				};
				if ( state === 'show' ) {
					// switch off the other menus if open:
					sg.navigation.toggleSearch( 'hide', true );
					sg.navigation.toggleCart( 'hide', true );
					sg.navigation.toggleMobileMenu( 'hide', true );
					sg.cached.nav.$menuDrawer.addClass( 'active' ); 
					sg.cached.ui.$siteNavCurrency.show();
					sg.cached.btn.$btnIconCurrency.parent('a').addClass( 'active-tab' );
					sg.cached.btn.$btnIconCurrency.removeClass( 'sg-euro_symbol' ).addClass( 'sg-close' );
					sg.cached.nav.$navCurrency.addClass('js-tab-visible');
					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'show' );
					}
				}
				else if ( state === 'hide' ) {
					sg.cached.ui.$siteNavCurrency.hide();
					sg.cached.nav.$menuDrawer.removeClass('.active');
					sg.cached.nav.$navCurrency.removeClass('js-tab-visible');
					sg.cached.btn.$btnIconCurrency.removeClass('sg-close').addClass('sg-euro_symbol');
					sg.cached.btn.$btnIconCurrency.parent('a').removeClass('active-tab');
					if ( overlay === true ) {
						sg.utilities.toggleOverlay ( 'hide' );
					}
				}
			}, // end sg.navigation.toggleCurrency

			toggleCart : function( state, overlay ) {

				if ( sg.cached.nav.$navCart.hasClass( 'js-tab-visible' ) ) {
					state = 'hide';
				};

				if ( state === 'show' ) {
					// switch off the other menus if open:
					sg.navigation.toggleSearch( 'hide', true );
					sg.navigation.toggleCurrency( 'hide', true );
					sg.navigation.toggleMobileMenu( 'hide', true );
					sg.cached.nav.$menuDrawer.addClass( 'active' ); // was .active in old script ??!
					sg.cached.ui.$siteNavCart.show();
					sg.cached.nav.$navCart.addClass( 'js-tab-visible' );
					sg.cached.btn.$btnIconCart.parent('a').addClass( 'active-tab' );
					sg.cached.btn.$btnIconCart.removeClass( 'sg-bag' ).addClass( 'sg-close' ); // can the two not be combined?
					if ( CartJS.cart.item_count > 0 ) {
						sg.cached.ui.$cartBtnWrapper.show();
					}
					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'show' );
					}
				}
				else if ( state === 'hide' ) {
					if ( CartJS.cart.item_count > 0 ) {
						sg.cached.ui.$cartBtnWrapper.hide();
					}
					sg.cached.ui.$siteNavCart.hide();
					sg.cached.nav.$menuDrawer.removeClass( 'active' );
					sg.cached.nav.$navCart.removeClass( 'js-tab-visible' );
					sg.cached.btn.$btnIconCart.addClass( 'sg-bag' ).removeClass( 'sg-close' );
					sg.cached.btn.$btnIconCart.parent('a').removeClass( 'active-tab' );

					if ( overlay === true ) {
						sg.utilities.toggleOverlay( 'hide' );
					}
				}
			}, // end sg.navigation.toggleCart

			closeAllMenu : function() {
				sg.cached.nav.$categoryWrap.hide();
				sg.cached.nav.$menuTabs.removeClass('js-tab-visible');
				sg.navigation.toggleCurrency( 'hide', true );
				sg.navigation.toggleCart( 'hide', true );
				sg.navigation.toggleSearch( 'hide', true );
				sg.navigation.toggleMobileMenu( 'hide', true );
				sg.utilities.toggleOverlay ( 'hide' );
			}, // end sg.navigation.closeAllMenu

			iconMenuDistribute :function( event, current ) {
				// function to distribute the icon menu links to their respectful functions.
				event.preventDefault();
				
				var iconHandle = current.data( 'handle' );

				sg.cached.nav.$categoryWrap.hide(); // hide the main menu if it's present.
				sg.cached.nav.$menuTabs.removeClass( 'js-tab-visible' );

				if      ( iconHandle === 'nav-search' ) { sg.navigation.toggleSearch( 'show', true ); }
				else if ( iconHandle === 'nav-cart' ) { sg.navigation.toggleCart( 'show', true ); }
				else if ( iconHandle === 'nav-currency' ) { sg.navigation.toggleCurrency( 'show', true ); }
				else if ( iconHandle === 'mobilemenu' ) { sg.navigation.toggleMobileMenu( 'show', true ); }
				else {
					
				}
			} // end sg.navigation.iconMenuDistribute()
		}, // end sg.navigation

/*============================================================================
	gui
==============================================================================*/

		gui : {

			toggleMenuImage : function( current, state ) {
				var
				$current      = current,
				$currentImage = $current.data( 'linkimage' ),
				$target       = $current.closest( 'div.list-wrapper' ).next( 'div.category-images' ).children( 'img.js-menu-image' ),
				$imageDefault = $target.data( 'defaultimage' );
				if ( state === 'enter' ) {
					$target.stop( true, true ).fadeOut('fast').attr( "src", $currentImage ).stop( true, true ).fadeIn('fast');
				}
				else if ( state === 'leave' ) {
					$target.stop( true, true ).fadeOut('fast').attr( "src", $imageDefault ).stop( true, true ).fadeIn('fast');

				}
				
			}, // end sg.gui.toggleMenuImage

		}, // end sg.gui


/*============================================================================
	search
	Based on: https://github.com/carolineschnapp/search-autocomplete
==============================================================================*/

		search : {

			ajaxSearch : function() {

				var
				currentRequest  = null;

				// create the search result list to insert results into
				$('<ul class="search-results no-bullets" role="list"></ul>').prependTo( sg.cached.ui.$siteNavSearch ).hide();

				sg.cached.btn.$searchInput.attr( 'autocomplete', 'off' ).bind( 'keyup change', function() {

					var
					searchTerm  = $( this ).val(),
					searchUrl   = '/search?type=product,page,article&q=' + searchTerm + '*',
					resultList  = $( '.search-results' ); // new -> sg.cached.ui.$resultList

					if ( searchTerm.length >= 2 && searchTerm != sg.cached.btn.$searchInput.attr( 'data-old-term' ) ) {

						// searchSuggestion ?????

						sg.cached.btn.$searchInput.attr( 'data-old-term', searchTerm ); // set the search term
						if ( currentRequest != null ) currentRequest.abort();

						sg.cached.btn.$btnIconSearch.addClass( 'spinner' );

						// begin search request
						currentRequest = $.getJSON( searchUrl + '&view=json', function( data ) {

							sg.cached.btn.$btnIconSearch.removeClass( 'spinner' );
							resultList.empty();


							// IF no results were found do
							if ( data.results_count == 0 ) {
								
								var
								reply = $( '<a></a>' ).attr( 'href', '/pages/site-map' );

								reply.append('<span class="left"><span>Sorry, no result for <b>' + searchTerm + '</b> could be found.<br />Please try again.</span>');
								reply.wrap('<li class="error-entry" role="listitem"></li>');

								resultList.append( reply.parent() );
								resultList.fadeIn( 200 );

								sg.cached.ui.$siteNavSearch.addClass('search-results--active');
							
							}
							// else if results were found then 
							else {

								// sort the results
								data.results.sort( function( a, b) {
									return a.kind - b.kind; // kind is set in the search result json file.
								});
								sg.cached.ui.$siteNavSearch.show();

								// itterate over each search result
								$.each( data.results, function( index, item ) {

									if ( item.kind === 0 ) { // kind 0 is products
										var productlink = $( '<a></a>' ).attr( 'href', item.url );
										productlink.append('<span class="left"><img src="' + item.thumbnail + '" class="product--image"/></span>');
										productlink.append('<span class="left product-entry--description"><span class="h5">' + item.title + " " + item.type + '</span><span>' + item.material + '</span>');
										productlink.wrap('<li class="search-results--products" role="listitem"></li>');
										resultList.append( productlink.parent() );
									}
									else if ( item.kind === 1 ) { // kind 1 is collection pages
										var collectionLink = $( '<a></a>' ).attr( 'href', item.url );
										collectionLink.append('<span class="left"><img src="' + item.img + '" class="product--image"/></span>');
										collectionLink.append('<span class="left product-entry--description"><span class="h5">' + item.title + '</span><span><i>"' + item.desc + '"</i></span>');
										collectionLink.wrap('<li class="search-results--products" role="listitem"></li>');
										resultList.append( collectionLink.parent() );
									}
									else if ( item.kind === 2 ) { // kind 2 is pages
										var pagelink = $( '<a></a>' ).attr( 'href', item.url );
										pagelink.append('<span class="h5">' + item.title +'</span><span><i>' + item.desc + '</i></span>');
										pagelink.wrap('<li class="search-results--pages" role="listitem"></li>');
										resultList.append( pagelink.parent() );
									}
									else if ( item.kind === 3 ) { // kind 3 is articles
										var articlelink = $( '<a></a>' ).attr( 'href', item.url );
										articlelink.append('<span class="h5">' + item.title + ' <i> – ' + item.date + '</i></span><span class="text-small">' + item.blog + '</span><br><span><i>' + item.excpt + '</i></span>');
										articlelink.wrap('<li class="search-results--articles" role="listitem"></li>');
										resultList.append( articlelink.parent() );
									}
								}); // end itteration on search results
								if ( data.results_count > 2 ) {
									// -------- >
								}
								resultList.fadeIn( 200 );
								sg.cached.ui.$siteNavSearch.show().addClass( 'search-results--active' );
								
							} //end else
						}); // end $.getJSON
					} // end if ( search terms )
					else if ( searchTerm.length == 0 ) {
						resultList.empty();
						sg.cached.ui.$siteNavSearch.hide().removeClass( 'search-results--active' );
					} // end else if
				}); // end input action.
			} // end sg.search.ajaxSearch();

		}, // end sg.search


/*============================================================================
	geo
==============================================================================*/

	geo : {

		// Assumption: place common countries at top for quicker loop itteration (?)
		countryLookup : {

			// UK
			"GB" : { "currency" : "GBP", "size" : "UK", "region" : "FRE" },

			// Europe
			"BE" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"DK" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"DE" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" }, 
			"ES" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"FR" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"GR" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"NO" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"NL" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"IT" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"PT" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"PL" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"SE" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" }, 
			"VA" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"LU" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"IS" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"IE" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },
			"AT" : { "currency" : "EUR", "size" : "EU", "region" : "EUC" },

			// None EU Europe
			"BG" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"BA" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"RO" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"UA" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"SM" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"SK" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"SI" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"MC" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"HU" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"HR" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"GE" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"FI" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" }, 
			"CZ" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },
			"CH" : { "currency" : "EUR", "size" : "EU", "region" : "NEU" },

			// North America
			"US" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"MX" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"VI" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"CA" : { "currency" : "CAD", "size" : "US", "region" : "INT" },

			// Rest of the World
			"JP" : { "currency" : "JPY", "size" : "US", "region" : "INT" },
			"TR" : { "currency" : "EUR", "size" : "EU", "region" : "INT" },
			"SG" : { "currency" : "GBP", "size" : "UK", "region" : "INT" },
			"AU" : { "currency" : "AUD", "size" : "UK", "region" : "INT" },
			"NZ" : { "currency" : "AUD", "size" : "UK", "region" : "INT" },
			"MO" : { "currency" : "GBP", "size" : "UK", "region" : "INT" },
			"KR" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"CN" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"BR" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"IL" : { "currency" : "USD", "size" : "US", "region" : "INT" },
			"MY" : { "currency" : "GBP", "size" : "UK", "region" : "INT" },
			"HK" : { "currency" : "GBP", "size" : "UK", "region" : "INT" },

			
		}, // end sg.geo.countrySizeMapping()

		getLocation : function() {
			$.getJSON( 'https://freegeoip.net/json/', function( location ) {

				console.log( location );
				if ( location.country_code ) {
					if ( sg.geo.countryLookup[location.country_code] ){
						console.log('country code matched in country lookup');
						var userCurr = sg.geo.countryLookup[location.country_code].currency,
								userSize = sg.geo.countryLookup[location.country_code].size,
								userRegi = sg.geo.countryLookup[location.country_code].region;
						Cookies.set('sg_pref', { currency: userCurr, size: userSize, region: userRegi}, { expires: 14, secure: sg.cached.flags.secureCookies });
					}
				}
				else {
					console.log('country code not exsist');
				}
				
			})
			.done( function() { 
				// console.log( Cookies.getJSON('sg_pref').region );
			})
			.fail( function() { 
			})
			.always( function() {
			});

		}, // end sg.geo.getLocation()

		setUserPreference : function() {
			if ( !( Cookies.get( 'sg_pref' ) ) ) {
				sg.geo.getLocation();
			}
			else {
				console.log( 'cookie exsist no need to fetch anything ');
				sg.currencyOption.setCurrency( Cookies.getJSON('sg_pref').currency );
				//sg.sizeOption.setSize( Cookies.getJSON('sg_pref').size );
			}

		} // end sg.geo.setUserPreference()

	}, // end sg.location

/*============================================================================
	currency option
==============================================================================*/

	currencyOption : {

		getCurrency : function() {
			if ( Cookies.get( '' ) != null ) {


			}
			else {


			}
		}, // sg.currencyOption.getCurrency()

		setCurrency : function( userCurrency ) {
			console.log( userCurrency );


		}, // sg.currencyOption.setCurrency()

		switchCurrency : function() {

		} // sg.currencyOption.switchCurrency()

	}, // end sg.currencyOption

/*============================================================================
	size option
==============================================================================*/

	sizeOption : {

		getSize : function( userDefaultSize ) {
			cachedCookieValue = Cookies.get( 'sg_uso' );
			if ( cachedCookieValue != null ) {
				console.log('cookie exist');
				if ( cachedCookieValue == userDefaultSize ) {
					console.log('cookie value is the same as IP find');
					sg.sizeOption.switchSize( cachedCookieValue );
					return;
				}
				else {
					console.log('cookie value is not the same as IP but will leave it at the selected');
					sg.cached.btn.$sizePicker.val( cachedCookieValue ).change();
					sg.sizeOption.switchSize( cachedCookieValue );
				}
			}
			else {
				console.log('cookie does not exist');
				if ( userDefaultSize ) {
					console.log( 'IP value found - setting cookie to IP value of: ' + userDefaultSize );
					Cookies.set('sg_uso', userDefaultSize, { expires: 7, secure: sg.cached.flags.secureCookies } );
				}
				else {
					console.log('userdefailt doest not exsist - creating cookie  with default UK value ');
					Cookies.set('sg_uso', 'uk', { expires: 7, secure: sg.cached.flags.secureCookies } );
				} 
			}
		}, // sg.sizeOption.getSize()

		setSize : function(  ) {

			// set the new size option in the size cookie
			// Cookies.set('sg_uso', sg.cached.btn.$sizePicker.val(), { expires: 7, secure: sg.cached.flags.secureCookies } );
			if ( Cookies.get( 'sg_pref' ) ) {
				sg.sizeOption.switchSize( Cookies.getJSON('sg_pref').size );
			}

		}, // sg.sizeOption.setSize()

		switchSize : function( selectedSize ) {

			console.log(selectedSize);

			sg.cached.btn.$sizePicker.val( selectedSize );
			sg.cached.btn.$sizePicker.change();

			// if on product page
			if ( productSizes != 'undefined' ) { // check if we have the product sizes list which is only produced on product pages
				
				console.log(productSizes);

				sg.cached.products.$sizeLabel.text( selectedSize + ' sizes');
				sg.cached.products.$sizeSelector.find( 'option:gt(0)' ).remove();

				$.each( productSizes, function( key, value ){
					console.log(key);
					if ( key === selectedSize ) {
						$.each( value, function( k, v ){
							$( '<option value="' + v.variantId + '">' + v.size + '</option>' ).insertAfter( sg.cached.products.$sizeLabel );
						});
					} // end if
				}); // end $.each
			} else {
				return;
			}

		} // end sg.sizeOption.switchSize()

	}, // end sg.sizeOption

/*============================================================================
	cart
==============================================================================*/

	cart : {

		submitToCart : function() {
			event.preventDefault();
			console.log('cart button clicked from main.js');
			// change buy botton status to processing
			sg.cached.products.$btnBuy.addClass( 'cart-btn--processing' );

			// check if a valid varient size 
			sg.cart.variantChecker();



		}, // end sg.cart.submitToCart()

		variantChecker : function() {
			if ( sg.cached.products.$sizeSelector.val() == null ) {
				// change button to error !!!
				sg.cached.products.$btnBuy.addClass( 'cart-btn--error' );
				sg.cached.products.$sizeSelector.addClass( 'error' );
				console.log('error in variant');
				return;
			}
			else {
				// if variant is valid then add to cart
				console.log('No error in variant');
				sg.cached.products.$btnBuy.removeClass( 'cart-btn--error' ).addClass( 'cart-btn--processing' );
				sg.cached.products.$sizeSelector.removeClass( 'error' );
				sg.cart.addToCart( sg.cached.products.$sizeSelector.val(), 1 ) // hard coded quantity - needs to change
			}

		}, // end sg.cart.variantError();

		addToCart : function( variantId, quantity ) {
			CartJS.addItem( variantId, quantity, {
			}, {
				success : function( data, textStatus, jqXHR ) {
					sg.cached.products.$btnBuy.removeClass( 'cart-btn--processing' );
					var
					$addonCheck = $( 'input[name="product_addon"]' );
					if ( $addonCheck && $addonCheck.is( ':checked' ) == true ) {
						console.log( 'add on available and checked ');
						sg.cart.addon.include();
					}
					sg.navigation.toggleCart( 'show', true );
				},
				error : function( jqXHR, textStatus, errorThrown ) {
					console.log('Error: ' + errorThrown + '!');
					sg.cached.products.$btnBuy.addClass( 'cart-btn--error' );
				}
			});
		}, // end sg.cart.addToCart();

		addon : {
			update : function( current ){
				if ( current.val() != '' ) {
					sg.cached.products.$addonAccept.text( "Add Engraving" );
					$( 'input[name="product_addon"]' ).removeAttr("disabled");
				}
			}, // end sg.cart.addon.update

			process : function( current ){
				var
				$current = current;
				sg.cached.products.$engravingInput.each( function(){
					console.log( $(this).val() );
				});

				current.closest( '.pop-window' ).fadeOut( 'fast' );
				sg.cached.ui.$popBackground.removeClass( 'shown' ).addClass( 'hidden' );	
			}, // end sg.cart.addon.process

			include : function(){
				var
				$addonForm = $( 'form.addon-form' ),
				$addonProductId = $addonForm.data( 'addonid' ),
				$addonFormEngraving = $addonForm.children(),
				$engravingOptions = {};

			//	CartJS.addItem( $addonProductId, 1, $engravingOptions );

				$addonFormEngraving.each(function() {
					if( $(this).val() != '' ){  
						$engravingOptions[this.name] = this.value;
					}
				});

				CartJS.addItem( $addonProductId, 1, $engravingOptions );

			} // end sg.cart.addon.add
		}
	}, // end sg.cart

/*============================================================================
	forms
==============================================================================*/

/*============================================================================
	newsletter
==============================================================================*/

	newsletter : {

		formProcess : function( e, signupForm ) {
			e.preventDefault();

			var
			currentForm = signupForm;


			signupForm.submit( function() {
				if ( !sg.newsletter.formValidate( signupForm ) ) {
					var
					error = "A valid email address must be provided.";
					resultElement.html( error );
					resultElement.css("color", "red");
				} else {
					resultElement.css("color", "black");
					resultElement.html("Please hold...");
					sg.newsletter.signupSubmit( signupForm, resultElement );
				}
			});
		}, // end sg.newsletter.formProcess

		formValidate : function( signupForm ) {
			var email = signupForm.find("input[type='email']").val();
			
			if (!email || !email.length) {
				
				return false;
			
			} else if (email.indexOf("@") == -1) {
			   
				return false;
			}
			return true;

		}, // end sg.newsletter.formValidate

		formSubmit : function( signupForm, resultElement ) {
			$.ajax({
				type 				: "GET",
				url 				: signupForm.attr( "action" ),
				data 				: signupForm.serialize(),
				cache 			: false,
				dataType 		: "jsonp",
				jsonp 	 		: "c",
				contentType : "application/json; charset=utf-8",

				error 			: function( error ) {
					console.log( 'signup Form error' );
				},

				success 		: function( data ) {
					if ( data.result != 'success' ) {
					var
					message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
					resultElement.css("color", "red");
					if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
						message = "You're already subscribed. Thank you.";
						$resultElement.css("color", "black");
					}
					$resultElement.html(message);
					} else {
						$(".mc-field-group").hide();
						$resultElement.css("color", "black");
						$resultElement.html("Thank you!<br>Please check you inbox for confirmation email.");
						$('#mce-EMAIL').val('');
					}
				}
			}) // end ajax request

		}, // end sg.newsletter.formSubmit

	}, // end sg.newsletter

/*============================================================================
	collection template
==============================================================================*/

	collection : {

		makeProductEntries : function() {

			var
			allProductTypes = [],
			allProductMaterials = [],
			allProductTypes = [];
			sg.cached.collection.$paginationUi.hide();

			if ( typeof collection_page_count === 'undefined' || collection_page_count === null ) {
				console.log( 'varible undefined' );
			}
			else {
				for (i = 2; i <= collection_page_count; i++ ) {
					
					$.get( collection_base_url + i, function( data ){  
						 var item = $( data ).find( 'div.product-entry' );
						 sg.cached.collection.$productList.append( item ); 
					}).done( function(){ 
					console.log('done');
					//sg.collection.imagehover();

					}); // end get
					//console.log(i);
					//console.log(collection_page_count);

					//if ( i = collection_page_count && fetch == 'complete' ) {
						//sg.collection.showProducts();
						console.log('ran');
					//} // end if
				} // end for 
			} // end if


			$( 'div.product-entry' ).each( function(){ 

				var
				current         = $(this),
				currentType     = current.data( 'type' ),
				currentMaterial = current.data( 'material' );
				//currentPrice    = current.data( 'price' );

				console.log(currentType);

				if ( !( $.inArray( currentType, allProductTypes ) >= 0) ) {
					allProductTypes.push( currentType );
					sg.cached.collection.$sortByType.append('<option value="' + currentType + '">' + currentType + '</option>');
				}

				if ( !( $.inArray( currentMaterial, allProductMaterials ) >= 0) ) {
					allProductMaterials.push( currentMaterial );
					sg.cached.collection.$sortByMaterial.append('<option value="' + currentMaterial + '">' + currentMaterial + '</option>');
				}

			});
			console.log(allProductTypes);
			console.log(allProductMaterials);
		}, // end sg.collection.showProducts()

		sorter : function( current ) {

			var
			$selector = current,
			$value    = $selector.children(':selected').val();

			if ( $selector.is( '#sortByType' ) ) {
				console.log( 'sort by type selected' + $value );
				sg.collection.sort.byType( $value );
			}
			if ( $selector.is( '#sortByMaterial' ) ) {
				console.log( 'sort by material selected' + $value );
				sg.collection.sort.byMaterial( $value );
			}
			if ( $selector.is( '#sortByPrice' ) ) {
				console.log( 'sort by price selected' + $value );
				sg.collection.sort.byPrice( $value );
			}
		}, // end sg.collection.sorter

		sort : {

			byType : function( currentValue ) {

				if ( currentValue === 'all_type' ) {
					console.log('sort by type called');
					$( 'div.product-entry' ).each( function(){ 
						$(this).show( 'fast' ); 

						//
						// sort something generic
						//

					});
				}
				else {
					$( 'div.product-entry' ).each( function(){ 
						var
						current         = $(this),
						currentType     = current.data( 'type' );
						if ( currentType === currentValue ) {
							$.scrollTo( 0, 600 );
							current.detach().insertAfter( $( '.collection-static--image' ) );
						}
					});
				}

			}, // end sg.collection.sort.byType

			byMaterial : function( a, b ) {

				var
				compA = $( a ).data('material'),
				compB = $( b ).data('material');
				return ( compA < compB ) ? -1 : ( compA > compB ) ? 1 : 0;

			}, // end sg.collection.sort.byMaterial

			byPrice : function( a, b ) {
				
				var
				compA = $( a ).data('price'),
				compB = $( b ).data('price');
				return ( compA < compB ) ? -1 : ( compA > compB ) ? 1 : 0;

			}, // end sg.collection.sort.byPrice

		}, // end sg.collection.sort

		imageToggle : function() {

			var 
			$entries  = $( '.product-entry' ),
			$button   = sg.cached.collection.$viewToggleBtn,
			$state    = $button.data( 'currentview' );

			if ( $state == 'model' ) {
				// the set to product
				$button.text( 'Model view' ).data( 'currentview', 'product' );
				$entries.each( function() {
					var
					$this           = $(this),
					$imageTag       = $this.children( 'a.product-entry--link' ).children( 'div.product-entry--image-wrapper' ).children( 'img.lazy-entry' ),
					$originalImage    = $this.data( 'originalimage' );
					$imageTag.attr( 'src', $originalImage );
				});

			}
			else if ( $state == 'product' ) {
				// then set to model
				$button.text( 'Jewellery view' ).data( 'currentview', 'model' );

				$entries.each( function() {
					var
					$this           = $(this),
					$imageTag       = $this.children( 'a.product-entry--link' ).children( 'div.product-entry--image-wrapper' ).children( 'img.lazy-entry' ),
					$modelImage     = $this.data( 'modelimage' );
					$imageTag.attr( 'src', $modelImage );
				});
			}
		}, // end sg.collection.imageToggle

		imageHover : function( current, state ) {
			// ensure we only do hover on the collection template.
			if ( sg.cached.page.$body.hasClass( 'template-collection' ) ) {
				var
				$viewstate      = sg.cached.collection.$viewToggleBtn.data( 'currentview' ),
				$current        = current,
				$originalimage  = $current.closest( '.product-entry' ).data( 'originalimage' ),
				$modelimage     = $current.closest( '.product-entry' ).data( 'modelimage' );

				if ( state == 'enter' ) { 
					if ( $viewstate == 'product' ) {
						$current.attr( 'src', $modelimage );
					}
					else if ( $viewstate == 'model' ) {
						$current.attr( 'src', $originalimage );
					}
				}
				else if ( state == 'leave' ) {
					if ( $viewstate == 'product' ) {
						$current.attr( 'src', $originalimage );
					}
					else if ( $viewstate == 'model' ) {
						$current.attr( 'src', $modelimage );
					}
				}
			} // end if 
		}, // sg.collection.imagehover

		showProducts : function() {
			// $("img.lazy-entry").lazyload({
			//  effect : "fadeIn",
			//  threshold : 200
			// });
		},

	}, // end sg.collection

/*============================================================================
	product template
==============================================================================*/

	products : {

		personalise : function() {
			console.log( 'personaliser clicked' );
		}

	}, // end sg.product

/*============================================================================
	moodboard template
==============================================================================*/

	moodboard : {

		contentRequest : function() {

			//sg.cached.flags.moodboardLoading = true;

			sg.moodboard.loading( true );

			console.log( 'limit ' + sg.cached.tumblr.$limit);
			console.log( 'offset ' + sg.cached.tumblr.$offset);

			$.ajax({
				url: sg.cached.tumblr.$name + "/posts?api_key=" + sg.cached.tumblr.$key + "&limit=" + sg.cached.tumblr.$limit + "&offset=" + sg.cached.tumblr.$offset,
				dataType: 'jsonp',
				success: sg.moodboard.loadContent,
				beforeSend: console.log( 'sending request now...' )
			});

		}, // sg.moodboard.contentRequest

		loadContent : function( data ) {

			if ( data.meta.status == 200 ) { // tumblr api always returns 200 - check meta.status for actual status.
				
				// Increment page index for future calls.
				sg.cached.tumblr.$offset = sg.cached.tumblr.$limit + sg.cached.tumblr.$offset;
				
				var
				entry = '',
				i = 0,
				responseLength = data.response.posts.length,
				image;

				for(; i < responseLength; i++) {
					if ( data.response.posts[i].type === 'photo' ) {

						image = data.response.posts[i];

						entry += '<div class="masonry-grid-item">';
						entry += '<div class="share-overlay">'
					
						
						entry += '<ul class="inline-list no-bullets">';
						entry += '<li><a href="#" class="icon-fallback-text sharecons js-pin-mediashare" data-articleurl="'+image.post_url+'" data-articletitle="SMITH/GREY moodboard" data-articleimage="'+image.photos[0].original_size.url+'"><span class="icon sg-pinterest"></span><span class="fallback-text">pinterest</span></a></li>';
						entry += '<li><a href="#" class="icon-fallback-text sharecons js-fb-mediashare" data-articleurl="'+image.post_url+'" data-articletitle="SMITH/GREY moodboard" data-articleimage="'+image.photos[0].original_size.url+'"><span class="icon sg-facebook"></span><span class="fallback-text">facebook</span></a></li>';
						entry += '</ul></div>'

						// Image tag (preview in Wookmark are 200px wide, so we calculate the height based on that).
						entry += '<img src="'+ image.photos[0].original_size.url +'" width="400" height="'+Math.round(image.height/image.width*400)+'">';
						// Image title.
						entry += '</div>';
						$moodboardContent = $( entry ); // must wrap content in $ object as masonry does not append pure html
					} // end if - check if post is of type photo
				} // end for itt for respodse
				
				if ( i >= responseLength ) {					
					
						sg.cached.pages.$moodboardWrap.imagesLoaded( function() {
							window.setTimeout( function(){
							sg.cached.pages.$moodboardWrap.append( $moodboardContent ).masonry( 'appended', $moodboardContent );
						$( '#moodboard-entries-wrapper' ).masonry();
						console.log( i );
						sg.moodboard.loading( false );
						}, 1500);
					});
						if ( i < sg.cached.tumblr.$limit ) {
							sg.cached.btn.$loadMoreContent.attr('disabled', 'disabled' ).text( 'Nothing more to show' );
						}
				} // end if
			}
			else {
				console.log( 'error in the tumblr request please try again' );
			}
			// sg.cached.pages.$moodboardWrap.masonry();
		}, // sg.mooodboard.loadContent

		loading : function( state ) {
			if ( state === true ) {
				sg.cached.pages.$contentLoading.fadeIn( 'fast' ); 
			}
			else if ( state === false ) {
				sg.cached.pages.$contentLoading.fadeOut( 'fast' );
			}
		},

		shareOverlay : function( current, state ){
			var
			$current = current;
			if ( state == 'enter' ) { 
				$current.children( '.share-overlay' ).fadeIn( 'fast' );	
			}
			else if ( state == 'leave' ) { 	
				$current.children( '.share-overlay' ).fadeOut( 'fast' );
			}
		}, // end sg.moodboard.shareOverlay
	}, // end sg.moodboard

/*============================================================================
	flickity
	https://github.com/metafizzy/flickity
==============================================================================*/

	flickity : {

		productSlider : function() {
			$productGallery = sg.cached.products.$imageGallery.flickity({
				contain: true,
				wrapAround: true,
				imagesLoaded: true,
				lazyLoad: true,
				cellSelector: '.gallery-cell',
				autoPlay: false
			});
		}, // end sg.flickity.productSlider

		productThumbnailSlider : function() {
			var
			$cellButtonGroup = $('#ProductThumbs'),
			$cellButtons = $cellButtonGroup.find('.product-single__thumbnail');

			$cellButtonGroup.on( 'click', '.product-single__thumbnail', function() {
				var index = $(this).index();
				$productGallery.flickity( 'select', index );
			});
		}, // end sg.flickity.productThumbnailSlider

		productZoom : function() {
			$('.tile').on('click', function(){
			$(this).children('.photo').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
			}).on('mouseout', function(){
			$(this).children('.photo').css({'transform': 'scale(1)'});
			}).on('mousemove', function(e){
			$(this).children('.photo').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
			}).each(function(){
			$(this).append('<div class="photo"></div>').children('.photo').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
			});
		}, // end sg.flickity.productZoom

		adaptiveHeight : function() {
			$('.js-flickity--adaptive').on( 'cellSelect', function() {
				$newTab = $(this).find('.is-selected'); 
				// $('.js-flickity--adaptive').find
				$(this).children('.flickity-viewport').delay(111).animate({height: $newTab.height()} );
			});
		}, // end sg.flickity.adaptiveHeight
	}, // end sg.flickity


/*============================================================================
	masonry
	https://github.com/desandro/masonry
==============================================================================*/

	masonry : {

		init : function() {
			$('.masonry-grid').masonry({
				itemSelector: '.masonry-grid-item',
				columnWidth: '.masonry-grid-item',
				percentPosition: true,
				gutter: 0,
				//fitWidth: true
			});
		}, // end sg.masonry.init

	}, // end sg.masonry

/*============================================================================
	youtube
	https://developers.google.com/youtube/iframe_api_reference
==============================================================================*/


/*============================================================================
	lazy loading
==============================================================================*/

	lazy : {

		init : function() {

			$(".lazy-entry").recliner({
				attrib: "data-src",
				throttle: 50,
				threshold: 100,
				printable: true,
				live: true
			});

		}, // end sg.lazy.init

		revealAssociatedContent : function( current ) {

			var
			$body = sg.cached.page.$body,
			$this = current;

			if ( $body.hasClass( 'template-index' ) ) {
				$this.prev( '.index-overlay-text' ).delay( 600 ).animate({
						opacity: 1
				}, 200 );
			}
			else if ( $body.hasClass( 'template-collection' ) ) {
				$this.parent( '.product-entry--image-wrapper' ).next( '.product-entry--description-wrapper' ).delay( 600 ).animate({
						opacity: 1
				}, 200 );
			}
			else if ( $body.hasClass( 'template-' ) ) {
				return;
			}
			else if ( $body.hasClass( 'template-' ) ) {
				return;
			}
			else if ( $body.hasClass( 'template-' ) ) {
				return;
			}

		}, // end sg.lazy.index()

	}, // sg.lazy

/*============================================================================
	sharing
==============================================================================*/

	sharing : {

		init : {
			facebook : function() {
					$.ajaxSetup({ cache: true });
					$.getScript('//connect.facebook.net/en_US/sdk.js', function(){
						FB.init({
							appId: '250314172004487',
							version: 'v2.5' // or v2.0, v2.1, v2.2, v2.3
						});     
					});
			}, // end sg.sharing.init.facebook

			pinterest : function(d) {
				var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
				p.type = 'text/javascript';
				p.async = true;
				p.src = '//assets.pinterest.com/js/pinit.js';
				f.parentNode.insertBefore(p, f);
			}
		}, // end sg.sharing.init

		facebook : {

			shareMedia : function( current ) {
				event.preventDefault();

				var
				$this = current,
				$articleLink = $this.data( 'articleurl' ),
				$articleImage = $this.data( 'articleimage' ),
				$articleTitle = $this.data( 'articletitle' ),
				$articleDescription = $this.data( 'articledescription' ),
				$articleHashtags = $this.data( 'articlehashtags' );

				FB.ui({
				method: 'share',
				display: 'popup',
				href: $articleLink,
				hashtag: $articleHashtags,
				mobile_iframe: true,
				title: $articleTitle,  // The same than name in feed method
				picture: $articleImage,  
				caption: 'your_caption',  
				description: $articleDescription
				}, function(response){});

			}, // end sg.sharing.facebook.shareMedia

			shareProduct : function( current ) {
				return;
			}
		}, // end sg.sharing.facebook

		pinterest : {

			shareMedia : function( current ) {
				event.preventDefault();

				console.log( 'clicked' );
				console.log( current );

				var
				$this = current,
				$articleLink = $this.data( 'articleurl' ),
				$articleImage = $this.data( 'articleimage' ),
				$articleTitle = $this.data( 'articletitle' ),
				$articleDescription = $this.data( 'articledescription' ),
				$articleHashtags = $this.data( 'articlehashtags' );

				PinUtils.pinOne({
						media: $articleImage,
						description: $articleTitle + ' ' + $articleDescription + ' ' + $articleHashtags,
						url: $articleLink
				});
			}

		} // end sg.sharing.pinterest
	}, // end sg.sharing

/*============================================================================
	pop
==============================================================================*/

	pop : {

		show : function( current ) {
			var
			$this = current,
			$popWindowiD = $this.data( 'popwindow' )
			;
			$('#' + $popWindowiD).fadeIn( 'fast' );
			sg.cached.ui.$popBackground.removeClass( 'hidden' ).addClass( 'shown' );
		}, // end sg.pop.show

		hide : function( current ) {
			var
			$this = current,
			$popWindow = $this.parent( '.pop-window' );
			$popWindow.fadeOut( 'fast' );	
			sg.cached.ui.$popBackground.removeClass( 'shown' ).addClass( 'hidden' );		
		} // sg.pop.hide
	}, // end sg.pop


/*============================================================================
	event listeners
==============================================================================*/


		eventListeners : function() {



			sg.cached.menu.$iconMenuTab.on('click', function(){ sg.navigation.toggleIconMenu( $(this) ) } );
			sg.cached.btn.$btnFurl.on( 'click', function(){ sg.utilities.furl( $(this) ) });


			sg.cached.mobileMenu.$dockIconBtn.on( 'click', function(){ sg.navigation.toggleMobileFurl( $(this) )});








			// // left navigation elements
			// sg.cached.nav.$menuTabs.on( 'click mouseover', function(){ sg.navigation.toggleMenu( event, $(this) ) });     

			// // right navigation elements
			// sg.cached.nav.$navIcons.on( 'click', function(){ sg.navigation.iconMenuDistribute( event, $(this) ) });

			// sg.cached.nav.$categoryLink.on({
			// 	mouseenter: function () { sg.gui.toggleMenuImage( $(this), 'enter' ); },
			// 	mouseleave: function () { sg.gui.toggleMenuImage( $(this), 'leave' ); }
			// });

			// // size option selector
			// sg.cached.btn.$sizePicker.on( 'change', function(){ sg.sizeOption.setSize() });

			// // Dismiss content overlay
			// sg.cached.ui.$overlay.on( 'click', function() { sg.navigation.closeAllMenu() });

			// // Furl function

			// // model / product image toggle
			// sg.cached.collection.$viewToggleBtn.on( 'click', function(){ sg.collection.imageToggle() });

			// // collection sort : by type
			// sg.cached.collection.$sortByType.on( 'change', function(){ sg.collection.sorter( $(this) ) });

			// // collection sort : by type
			// sg.cached.collection.$sortByMaterial.on( 'change', function(){ sg.collection.sorter( $(this) ) });

			// // collection sort : by type
			// sg.cached.collection.$sortByPrice.on( 'change', function(){ sg.collection.sorter(  $(this) ) });





			// //product template
			// sg.cached.products.$btnBuy.on( 'click', function(){ sg.cart.submitToCart() });
			// sg.cached.products.$personaliser.on( 'click', function(){ sg.products.personalise() });
			// sg.cached.products.$engravingInput.on( 'change', function(){ sg.cart.addon.update( $(this) ) });
			// sg.cached.products.$addonAccept.on( 'click', function(){ sg.cart.addon.process( $(this) ) });

			












			// // index lazy load callback
			// $(document).on('lazyshow', '.lazy-entry', function(){ sg.lazy.revealAssociatedContent( $(this) ) });

			// $(document).on({
			// 	mouseenter: function () { sg.collection.imageHover( $(this), 'enter' ); },
			// 	mouseleave: function () { sg.collection.imageHover( $(this), 'leave' ); }
			// }, '.lazy-entry' );

			// // social media sharing 
			// $( '.js-fb-mediashare' ).on( 'click', function(){ sg.sharing.facebook.shareMedia( $( this ) ) });
			// //$( '.js-pin-mediashare' ).on( 'click', function(){ sg.sharing.pinterest.shareMedia( $( this ) ) });

			// $(document).on({
			// 	click: function(){ sg.sharing.pinterest.shareMedia( $( this ) ) }
			// }, '.js-pin-mediashare' );

			// $(document).on({
			// 	click: function(){ sg.sharing.facebook.shareMedia( $( this ) ) }
			// }, '.js-fb-mediashare' );

			// //$( document ).on( 'scroll', sg.moodboard.requestMore( document ) );

			// sg.cached.btn.$loadMoreContent.on( 'click', function(){ sg.moodboard.contentRequest() });

			// $(document).on({
			// 	mouseenter: function () { sg.moodboard.shareOverlay( $(this), 'enter' ); },
			// 	mouseleave: function () { sg.moodboard.shareOverlay( $(this), 'leave' ); }
			// }, '.masonry-grid-item' );

			// sg.cached.btn.$popOpener.on( 'click', function(){ sg.pop.show( $(this) )});
			// sg.cached.btn.$popDismiss.on( 'click', function(){ sg.pop.hide( $(this) )});



			// sg.cached.newsletter.$signupBtn.on( 'click', function(){ sg.newsletter.formProcess( event, $(this) )});


		}, // end sg.eventListeners


/*============================================================================
	initializer
==============================================================================*/

		initializer : function() {
			sg.cached;
			sg.eventListeners();


		} // end sg.initializer
	} // end sg

/*============================================================================

==============================================================================*/

	sg.initializer();

})( jQuery, window, document );




